/**
 * Saved views configuration for time entries
 * Pre-configured views for common time entry filtering scenarios
 */
export const TIME_ENTRY_SAVED_VIEWS = [
  {
    id: "all-time-entries",
    name: "All Time Entries",
    filters: {},
    sort: { field: "date_worked", direction: "desc" as const },
    visibleColumns: [
      "date_worked",
      "ticket_id",
      "company_id",
      "description",
      "hours",
      "user_id",
      "entry_type",
      "is_approved",
    ],
  },
  {
    id: "my-time-entries",
    name: "My Time Entries",
    filters: { user_id: "me" },
    sort: { field: "date_worked", direction: "desc" as const },
    visibleColumns: [
      "date_worked",
      "ticket_id",
      "company_id",
      "description",
      "hours",
      // The tracked window. The desktop timer has recorded both ends since
      // 2026-08-27 and the column has always existed, but no saved view ever
      // showed it — so the one place you could check your own day against what
      // was actually logged displayed a duration and nothing else.
      "start_time",
      "end_time",
      "entry_type",
      "is_approved",
    ],
  },
  {
    id: "pending-approval",
    name: "Pending Approval",
    filters: { is_approved: false },
    sort: { field: "date_worked", direction: "desc" as const },
    visibleColumns: [
      "date_worked",
      "ticket_id",
      "company_id",
      "description",
      "hours",
      // Approval IS the audit. "2 hours" is a claim; "9:00 AM - 11:00 AM" is
      // what an approver can weigh before a client is charged for it, and this
      // view is the last point at which that judgement is cheap to make.
      "start_time",
      "end_time",
      "user_id",
      "entry_type",
    ],
  },
  {
    id: "billable-entries",
    name: "Billable Entries",
    filters: { entry_type: "billable" },
    sort: { field: "date_worked", direction: "desc" as const },
    visibleColumns: [
      "date_worked",
      "ticket_id",
      "company_id",
      "description",
      "hours",
      // Shown beside billable_rate: rate x hours is the amount, and the window
      // is the evidence for the hours.
      "start_time",
      "end_time",
      "billable_rate",
      "user_id",
    ],
  },
  {
    id: "this-week",
    name: "This Week",
    filters: { date_worked: "this_week" },
    sort: { field: "date_worked", direction: "desc" as const },
    visibleColumns: [
      "date_worked",
      "ticket_id",
      "company_id",
      "description",
      "hours",
      "user_id",
      "entry_type",
    ],
  },
  {
    id: "quickbooks-sync",
    name: "QuickBooks Sync",
    filters: { sync_status: "pending" },
    sort: { field: "date_worked", direction: "desc" as const },
    visibleColumns: [
      "date_worked",
      "ticket_id",
      "company_id",
      "description",
      "hours",
      "sync_status",
      "is_approved",
    ],
  },
];
